import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import BottomNav from './BottomNav';

interface MainLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout principal que incluye Header y BottomNav
 */
export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();

  /**
   * Obtiene el título según la ruta actual
   */
  const getPageTitle = (): string => {
    switch (location.pathname) {
      case '/':
        return 'Home';
      case '/equipo':
        return 'Equipo';
      case '/captacion':
        return 'Captación';
      case '/perfil':
        return 'Perfil';
      case '/crear-informe':
        return 'Crear Informe';
      case '/asistencia':
        return 'Asistencia a Entrenamientos';
      case '/jornadas':
        return 'Jornadas';
      default:
        return 'CorneApp';
    }
  };

  /**
   * Determina si debe mostrar el botón atrás
   */
  const shouldShowBackButton = (): boolean => {
    const mainRoutes = ['/', '/equipo', '/captacion', '/perfil'];
    return !mainRoutes.includes(location.pathname);
  };

  return (
    <div className="relative min-h-screen bg-slate-950 flex flex-col">
      {/* Fondo con logo */}
      <div 
        className="fixed inset-0 z-0 pointer-events-none opacity-40"
        style={{
          backgroundImage: `url(/cornella.png)`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '85%', 
          filter: 'blur(0px)', // Eliminamos el blur directo a la imagen para que se vea más nítida
        }}
      />
      
      {/* Capa de overlay para oscurecer y dar efecto "glaseado" */}
      <div className="fixed inset-0 z-0 bg-slate-950/50 pointer-events-none backdrop-blur-[3px]" />

      {/* Contenido principal */}
      <div className="relative z-10 flex flex-col flex-1 h-full overflow-hidden">
        <Header 
          title={getPageTitle()} 
          showBackButton={shouldShowBackButton()}
        />
        
        <main className="flex-1 flex flex-col pb-18 overflow-y-auto">
          {children}
        </main>
        
        <BottomNav />
      </div>
    </div>
  );
};

export default MainLayout;